"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardsMsgEncoder = exports.createRewardsAminoConverters = exports.rewardsTypes = void 0;
const arch3_proto_1 = require("@archwayhq/arch3-proto");
exports.rewardsTypes = arch3_proto_1.archway.rewards.v1.registry;
const createRewardsAminoConverters = () => arch3_proto_1.archway.rewards.v1.AminoConverter;
exports.createRewardsAminoConverters = createRewardsAminoConverters;
/**
 * Encodes the transaction messages for the `x/rewards` module.
 */
exports.RewardsMsgEncoder = arch3_proto_1.archway.rewards.v1.MessageComposer.fromPartial;
//# sourceMappingURL=tx.js.map